export const JOKER_LOADED = 'App loaded';
export const PLACE_BET_SVENSKA_SPEL = 'Place bet click: svenska spel';
export const PLACE_BET_DOWNLOAD_FILE = 'Place bet click: save file';
export const PLACE_BET_ATG = 'Place bet click: atg';
export const PLACE_BET_ATG_TILLSAMMANS = 'Place bet click: atg tillsammans';
export const PLACE_BET_RIKSTOTO = 'Place bet click: rikstoto';
export const PLACE_BET_CANCEL = 'Place bet click: cancel';
